import React from 'react';

import { SidebarLeftOutline } from '@lyearn/icons';
import { IconButton } from '@lyearn/ui';

export interface SidebarToggleProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

const SidebarToggle = (props: SidebarToggleProps) => {
  const { isCollapsed, onToggle } = props;

  return (
    <IconButton
      Icon={SidebarLeftOutline}
      appearance="secondary"
      aria-label={isCollapsed ? 'Show sidebar' : 'Hide sidebar'}
      aria-pressed={isCollapsed}
      className="bg-bg-secondary"
      disabled={!onToggle}
      shape="square"
      size="m"
      variant="ghost"
      onClick={onToggle}
    />
  );
};

export default React.memo(SidebarToggle);
